import React from 'react';
import classes from "../Foot/Foot.module.css";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCoffee, faEnvelope, faPhone} from '@fortawesome/free-solid-svg-icons';
import {faFacebookMessenger, faInstagram, faFacebook} from '@fortawesome/free-brands-svg-icons';





function Foot(){
    return(
        <div className={classes.footer}>
        <h2>CONTACT US</h2>
        <div className={classes.box}>
            
            

            <div className={classes.contactDeets}>
                <h5><FontAwesomeIcon icon={faEnvelope}  className={classes.socialIcon}/>: fragranciabd@gmail.com</h5>
                <h5><FontAwesomeIcon icon={faPhone}  className={classes.socialIcon}/>: 01765998605</h5>
                

            </div>

            <div className={classes.socials}>
                <h5>Follow us on:</h5>
            <a href="https://www.facebook.com/FragranciaBD"><FontAwesomeIcon icon={faFacebook}  className={classes.socialIcon} /></a>
            <a href="https://www.messenger.com/t/101379821733671"><FontAwesomeIcon icon={faFacebookMessenger}  className={classes.socialIcon}/></a>
            <a href="https://www.instagram.com/___fragrancia___/"><FontAwesomeIcon icon={faInstagram}  className={classes.socialIcon}/></a>
            

            </div>
       

        </div>
        </div>
      



    )
}

export default Foot;

